<template>
    <div class="intro box mt-5" id="rental-form" v-if="this.loaded">

        <div class="grid grid-cols-12 gap-6 pl-0 pr-5">

            <FormErrorBox />

            <div class="intro col-span-12 lg:col-span-6 pb-4">
                <div class="form-inline mt-5" style="margin-bottom: 16px;">
                    <label for="repair_date" class="form-label sm:w-40">Datum</label>
                    <VueDatePicker
                        format="dd.MM.yyyy"
                        locale="de"
                        cancelText="abbrechen"
                        selectText="auswählen"
                        v-model="form.repair_date"
                        :auto-apply="true"
                        class="form-control"
                        id="bought_date"
                        autocomplete="off"
                        style="max-width: 440px;"
                    />
                </div>

                <div class="form-inline mt-5">
                  <label for="description" class="form-label sm:w-40">Kommentar</label>
                  <textarea
                      id="description"
                      class="form-control"
                      v-model="form.description"
                  ></textarea>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1">
            <div class="px-5 pt-8 pb-8 text-center">
                <button
                    type="button"
                    @click="onClose"
                    class="btn btn-outline-warning w-24 mr-1"
                >
                    abbrechen
                </button>
                <button
                    type="button"
                    class="btn btn-success w-24"
                    @click="onSave"
                >
                    speichern
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import VueMultiselect from 'vue-multiselect';
import VueTimepicker from "vue3-timepicker";
import {Tab} from "../global-components/tab";
import FormErrorBox from "./FormErrorBox.vue";
import authHeader from "../services/auth-header";

export default {
    name: "RepairForm",

    components: {FormErrorBox, Tab, VueMultiselect, VueTimepicker },

    props: {
        instrument_id: {
            type: Number,
            required: true,
        },
        id: {
          type: Number,
          required: true,
          default: 0
        }
    },

    data() {
        return {
            loaded : false,
            form   : {}
        }
    },

    mounted() {
        this.form.instrument_id = this.instrument_id;
        this.form.id = this.id;

        if (this.id > 0) {
            axios
                .get(this.$store.state.config.apiUrl + '/repair/' + this.id, { headers: authHeader() })
                .then(response => {
                    this.form = response.data.item;
                    this.loaded = true;
                });
        } else {
            this.loaded = true;
        }
    },
    methods: {

        onSave() {
            $('#repair-form .text-danger').html('');
            $('#repair-form input.border-danger').removeClass('border-danger');

            if (this.form.id == null || this.form.id < 1) {
                this.create();
            } else {
                this.update();
            }
        },

        update() {
            axios
                .put(this.$store.state.config.apiUrl + '/repair/' + this.form.id, this.form, { headers: authHeader() })
                .then(response => {
                    this.$emit('save', response.data.item);

                    this.showNotification(true, 'Speichern', 'Die Daten wurden gespeichert');
                })
                .catch(response => {
                    this.showFormErrors(response.response.data.errors);
                });
        },

        create() {
            axios
                .post(this.$store.state.config.apiUrl + '/repair', this.form, { headers: authHeader() })
                .then(response => {
                    this.$emit('save', response.data.item);

                    this.showNotification(true, 'Speichern', 'Die Daten wurden gespeichert');
                })
                .catch(response => {
                    this.showFormErrors(response.response.data.errors);
                });
        },

        onClose() {
            for (let x = 0; x < this.form.length; x++) {
                this.form[x] = '';
            }
            this.$emit('close');
        },

        showFormErrors(error) {
            _.each(error, (message, key) => {
                key = key.replace('order.', '');
                $('#repair-form #' + key).addClass('border-danger');
                let box = $('#repair-form .text-danger');
                if (box != null) {
                    box.append('<p>' + message[0] + '</p>');
                }
            });
            $('.modal').animate({ scrollTop: 0}, 'fast');
        }
    }
}
</script>
